import { Action } from '@ngrx/store';
import { PartialCustomerUpdateRequest, UnSubscribeRequest } from '@app/api/models/api-models';

export enum AccSettingsActionTypes {
  DOWNLOAD_GDPR_ATTEMPT = '[Account Settings GDPR] Download Gdpr Attempt',
  DOWNLOAD_GDPR_SUCCESS = '[Account Settings GDPR] Download Gdpr Success',
  DOWNLOAD_GDPR_FAILURE = '[Account Settings GDPR] Download Gdpr Failure',

  UNSUBSCRIBE_ATTEMPT = '[Basic UnSubscribe Attempt] UnSubscribe Attempt',
  UNSUBSCRIBE_SUCCESS = '[Basic UnSubscribe Success] UnSubscribe Success',
  UNSUBSCRIBE_FAILURE = '[Basic UnSubscribe Failure] UnSubscribe Failure',

  CUSTOMER_UPDATE_ATTEMPT = '[CustomerUpdateAttempt] CustomerUpdate Attempt',
  CUSTOMER_UPDATE_SUCCESS = '[CustomerUpdateSuccess] CustomerUpdate Success',
  CUSTOMER_UPDATE_FAILURE = '[CustomerUpdateFailure] CustomerUpdate Failure',
}

export class UnSubscribeAttempt implements Action {
  readonly type = AccSettingsActionTypes.UNSUBSCRIBE_ATTEMPT;
  constructor(public payload: { request: UnSubscribeRequest }) {}
}

export class UnSubscribeSuccess implements Action {
  readonly type = AccSettingsActionTypes.UNSUBSCRIBE_SUCCESS;
  constructor(public payload: any) {}
}

export class UnSubscribeFailure implements Action {
  readonly type = AccSettingsActionTypes.UNSUBSCRIBE_FAILURE;
  constructor(public payload?: any) {}
}
export class CustomerUpdateAttempt implements Action {
  readonly type = AccSettingsActionTypes.CUSTOMER_UPDATE_ATTEMPT;
  constructor(public payload: { request: PartialCustomerUpdateRequest }) {}
}

export class CustomerUpdateSuccess implements Action {
  readonly type = AccSettingsActionTypes.CUSTOMER_UPDATE_SUCCESS;
  constructor(public payload: any) {}
}

export class CustomerUpdateFailure implements Action {
  readonly type = AccSettingsActionTypes.CUSTOMER_UPDATE_FAILURE;
  constructor(public payload?: any) {}
}

export class DownloadGdprAttempt implements Action {
  readonly type = AccSettingsActionTypes.DOWNLOAD_GDPR_ATTEMPT;
}

export class DownloadGdprSuccess implements Action {
  readonly type = AccSettingsActionTypes.DOWNLOAD_GDPR_SUCCESS;
}

export class DownloadGdprFailure implements Action {
  readonly type = AccSettingsActionTypes.DOWNLOAD_GDPR_FAILURE;
  constructor(public payload?: any) {}
}

export type AccSettingsActions =
  | UnSubscribeAttempt
  | UnSubscribeFailure
  | UnSubscribeSuccess
  | CustomerUpdateAttempt
  | CustomerUpdateSuccess
  | CustomerUpdateFailure
  | DownloadGdprAttempt
  | DownloadGdprSuccess
  | DownloadGdprFailure;
